import { getRequest, postRequest, putRequest, deleteRequest } from '../../services.js/apiService';

const API_URL = `${process.env.REACT_APP_API_URL}/v1`;

export const addAd = (data) => async () => postRequest(`${API_URL}/sponAd`, data);

export const updateDisplayOrder = (order) => async () => putRequest(`${API_URL}/sponAd/displayOrder/`, { order });

export const getAdById = (id) => async () => getRequest(`${API_URL}/sponAd/${id}`);

export const getAds = (query) => async () => getRequest(`${API_URL}/sponAds`, { ...query });

export const deleteAd = (id) => async () => deleteRequest(`${API_URL}/sponAd/${id}`);

export const deleteMedia = (id, url, fileType) => async () => deleteRequest(`${API_URL}/sponAd/${id}/media`, { url, fileType });

export const duplicateMedia = (id, data) => async () => postRequest(`${API_URL}/sponAd/${id}/duplicate`, data);

export const updateAd = (id, data) => async () => putRequest(`${API_URL}/sponAd/${id}`, data);

export const bulkUpdateAds = (ads) => async () => putRequest(`${API_URL}/sponAd`, { ads });

export const uploadMedia = (id, file) => async () => postRequest(`${API_URL}/sponAd/${id}/media`, file);
